module.exports = __webpack_public_path__ + "static/img/home-beds.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home-beds.png
// module id = 533
// module chunks = 0